import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import { instructorSearchConnector } from '../../server/connector/InstructorSearchConnector';
import { updateExploreProfiles } from '../../redux/reducers/searchSlice'
import BackToTopButton from '../../components/backToTopButton/BackToTopButton'
import HeaderAppExplore from '../../sections/header/HeaderAppExplore'
import AppSearchResultGrid from '../../sections/app_searchResultGrid/AppSearchResultGrid'
import AppFooter from '../../sections/footer/AppFooter'
import AppSearchMenu from '../../components/app_searchMenu/AppSearchMenu';
import AppSearchFilterMenu from '../../components/app_searchFilterMenu/AppSearchFilterMenu';
import AppSearchResultRows from '../../sections/app_searchResultRows/AppSearchResultRows';
import { userStateData } from '../../data/userStateData';
import { PAGE_URLS } from '../../constants/hrefLinks';

function AppExplore() {
	// const searchRequestInProgress: boolean = useAppSelector((state) => state.search.searchRequestInProgress)
	const resultProfiles = useAppSelector((state) => state.search.resultProfiles)
	const appShowSearchMenu: boolean = useAppSelector((state) => state.search.appShowSearchMenu)
	const appShowFilterMenu: boolean = useAppSelector((state) => state.search.appShowFilterMenu)
	const [firstSearchLoaded, setFirstSearchLoaded] = useState<boolean>(false)

	const dispatch = useAppDispatch()

	useEffect(() => {
		// Assumes the log in check is done in the root App component before any page components are added to the dom
		if (userStateData.loggedIn) {
			makeInitialSearchRequest()
		} else {
			window.location.replace(`${PAGE_URLS.APP_ENTRY}`)
		}
	}, [])

	const makeInitialSearchRequest = () => {
		instructorSearchConnector.performExploreSearchRequest().then((successRequest) => {
			setFirstSearchLoaded(true)
			dispatch(updateExploreProfiles())
			if (!successRequest) {
				console.log('WARNING - [AppExplore] - makeInitialSearchRequest() failed')
			}
		})
	}

	return (
		<>
			{firstSearchLoaded &&
				<>
					<div className='section-wrap'>
						<div className='section-content'>
							<HeaderAppExplore />
						</div>
					</div>
					<div className='section-wrap section-seperator lcp-shift-min-height extra-footer-space'>
						{resultProfiles.length > 0 ?
							<AppSearchResultGrid
								title='Search'
								profiles={resultProfiles}
							/> :
							<AppSearchResultRows />
						}
					</div>
					<BackToTopButton />
				</>
			}
			<AppFooter activeIndex={3} />
			{appShowSearchMenu && <AppSearchMenu />}
			{appShowFilterMenu && <AppSearchFilterMenu />}
		</>
	)
}

export default AppExplore
